/** Backend 403 body when business APIs are gated (TRG-626). */
export const BILLING_SUBSCRIPTION_INACTIVE_ERROR_TYPE =
  "subscriptionInactive" as const;

export const WEBSOCKET_BILLING_SUBSCRIPTION_ENDED =
  "billing-subscription-ended" as const;

export const BILLING_REACTIVATION_ROUTE = "/activate-service/billing";

export type BillingSubscriptionEndedReason =
  | "subscription_deleted"
  | "billing_suspended";

export type BillingLockoutSource = "http" | "websocket";
